import React, { useEffect, useState } from 'react';
import Bunexe_service from '../../Bunexe_service';
import { format, addDays } from 'date-fns';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { Link, Route, useHistory } from 'react-router-dom';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FaEdit } from 'react-icons/fa';
// import MyDocument from './MyTestComponent';
// import MyTestComponent from './MyTestComponent';

const Resume_perm = ({
  setCurrentform,
  currentform,
  candidatSelectionne,
  departement,
  siege_,
  sieges,
  info,
  email,
  tel,
  methode_paiement,
  setMethode_paiement,
}) => {
  let kk = Bunexe_service.depts.filter((d1) => d1.code == departement)[0];
  let url_ = Bunexe_service.url;

  let ss = sieges.filter((s) => s.IDSIEGE == siege_)[0];
  const [ecole_selection, setEcole_selection] = useState({});
  let histo = useHistory();

  const getEcole = async () => {
    try {
      fetch(url_ + `/ecole/perm_en_ligne/siege/${ss.IDSIEGE}`)
        .then((response) => response.json())
        .then((data) => {
          setEcole_selection(data);
          //setInfoPh(data);
          // setAlreadyLoaded(true);
        })
        .catch((err) => console.log(err));
    } catch (error) {
      console.log(error);
    }
  };

  const enregistrer = () => {
    //return <MyTestComponent />;
    //setCurrentform(currentform + 1);
    // imprimable();

    let Form_data = {
      identifiant: '',
      code_section: candidatSelectionne.IDSECTION,
      an_encours: '1920',
      anph_ancien: candidatSelectionne.ANNEE,
      matph_ancien: candidatSelectionne.MATRICULE,
      code_dept: ecole_selection.Code_direction,
      ecole: ecole_selection.Ecole,
      Code_siege: ecole_selection.CodeSiege,
      session_encours: 'B',
      session_ancien: candidatSelectionne.SESSION,
      statut: 'P',
      utilisateur: info.username ? info.username : 'sois-meme',
      email: email.replace("'", "''"),
      tel: tel,
    };
    console.table(Form_data);
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Form_data),
    };
    try {
      fetch(url_ + '/permph/add_eleve', requestOptions)
        .then((response) => {
          return response.json();
          //else throw Error(response.statusText);
        })
        .then((data) => {
          if (data.hasError) {
            toast.error(data.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
            //afficherMessage(data.message);
          } else {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Enregistrement Sauvegardé.',
              showConfirmButton: false,
              timer: 1500,
            });
            imprimable();
            // listeEleves_func(Ecole);
            // resetForm();
            // nomref.focus();
          }
          // console.log(data);
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (error) {
      console.error("Erreur d'insertion ...", error);
    }
  };

  const imprimable = () => {
    var doc = new jsPDF({ format: 'letter' });
    // let dd = districts_.filter((d) => d.CodeDistrict == district_);
    let pageHeight = 0;
    //console.log(JSON.stringify(dd));
    //let mydata2 = lesEleves;
    doc.setProperties({
      title: 'Impression Ecole ',
      subject: 'Liste des Inscrits',
      author: 'MENFP',
      keywords: 'menfp, bunexe',
      creator: 'BUNEXE',
    });
    let titre_ =
      "MINISTERE DE L'EDUCATION NATIONALE ET DE LA FORMATION PROGESSIONNELLE";
    //var totalPagesExp = '{total_pages_count_string}';

    var pageHeight1 =
      doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
    var pageWidth1 =
      doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
    let xOffset =
      doc.internal.pageSize.width / 2 -
      (doc.getStringUnitWidth(titre_) * doc.internal.getFontSize()) / 2;
    let Tt =
      Math.ceil(doc.getStringUnitWidth(titre_) / 2) *
      doc.internal.getFontSize();
    doc.setFontSize(18);
    // doc.text('Dieu mon sujet de Gloire !!!', 14, 22);
    doc.setFontSize(11);
    doc.setTextColor(100);

    // jsPDF 1.4+ uses getWidth, <1.4 uses .width
    var pageSize = doc.internal.pageSize;
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
    doc.setFontSize(12);
    // doc.setTextColor(100);
    doc.text(
      titre_.trim().toUpperCase(),
      pageWidth1 / 2 - (titre_.trim().toUpperCase().length * 2.6) / 2,
      22
    );
    let Sigle = '( M E N F P )';
    doc.text(
      Sigle.trim().toUpperCase(),
      pageWidth1 / 2 - (Sigle.trim().toUpperCase().length * 2.8) / 2,
      28
    );
    // doc.text(Sigle.trim().toUpperCase(), 24, 28, { align: 'center' });

    doc.text(
      kk.titre.trim().toUpperCase(),
      pageWidth1 / 2 - (kk.titre.trim().toUpperCase().length * 2.8) / 2,
      34
    );

    doc.text(
      ss.DENOMSI.trim().toUpperCase(),
      pageWidth1 / 2 - (ss.DENOMSI.trim().toUpperCase().length * 3.6) / 2,
      40
    );

    // doc.text(ss.DENOMSI.trim().toUpperCase(), 24, 40, { align: 'center' });

    let ligne = '_________________________________________________';
    doc.text(
      ligne.trim().toUpperCase(),
      pageWidth1 / 2 - (ligne.trim().toUpperCase().length * 3.0) / 2,
      44
    );

    // let formulaire = 'Fiche inscription en ligne au bac permanent : XXXX';
    // doc.text(
    //   formulaire.trim(),
    //   pageWidth1 / 2 - (formulaire.trim().toUpperCase().length * 3.0) / 2,
    //   50
    // );

    let dnaiss = `${format(
      addDays(
        new Date(
          candidatSelectionne.DNAISS.trim()
            .substr(0, 4)
            .concat('-')
            .concat(candidatSelectionne.DNAISS.trim().substr(4, 2))
            .concat('-')
            .concat(candidatSelectionne.DNAISS.trim().substr(6, 2))
        ),
        1
      ),
      'dd/MM/yyyy'
    ).trim()}`;
    let info_titre = 'Information sur le Candidat ';
    doc.text(
      info_titre.trim().toUpperCase(),
      pageWidth1 / 2 - (info_titre.trim().toUpperCase().length * 3.0) / 2,
      56
    );
    let nom_prenom = `
    Le Bunexe Certifie que le Candidat ${candidatSelectionne.NOMEL.trim()}  ${candidatSelectionne.PRENOMEL.trim()}, né(e) le ${dnaiss}
    à ${candidatSelectionne.LOCNAISS.trim()}, est inscrit(e) à la Session du Bac Permanent XXXX.
    `;
    // nom_prenom = doc.splitTextToSize(nom_prenom, 60).toString();
    doc.text(nom_prenom, 20, 66);

    let statut = 'Le statut du candidat est  << PENDANT >>';
    doc.text(statut, 60, 83);

    let recommandation = `
    Le Candidat est prié d'aller regler les formalités avec la BNC au #Compte xxxx,
    puis apporter la fiche de paiement à la direction departementale concernée `;
    // recommandation = doc.splitTextToSize(recommandation, 180);
    //recommandation = doc.splitTextToSize(recommandation, 60).toString();
    doc.text(recommandation, 20, 86);
    doc.setFontSize(11);
    // var text = 'Je suis celui qui vit par la grace de Dieu'; //doc.splitTextToSize(faker.lorem.sentence(45), pageWidth - 35, {})

    let tt = doc.output('blob');
    let nomfichier = `${candidatSelectionne.NOMEL.trim()}_${candidatSelectionne.PRENOMEL.trim()}.pdf`;
    doc.save(nomfichier);
    histo.push('/perm_en_ligne');
    let blobPDF = new Blob([tt], { type: 'application/pdf' });
    let bloburl = URL.createObjectURL(blobPDF);
    tt = bloburl;
    //setMydoc(tt);
    //     let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
    // width=0,height=0,left=-1000,top=-1000`;
    let params = `scrollbars=0,resizable=0,status=0,location=0,toolbar=0,menubar=0,
width=1200,height=600,left=200,top=120,status=0`;

    window.open(tt, 'Impression', params);
    histo.push('/');
    //setCurrentform(0);
    //doc.addPage();

    // doc.text(text, 14, doc.autoTable.previous.finalY + 10);
    // document.getElementById('output').src = doc.output('datauristring');
    // document.getElementById('output').data = doc.output('datauristring');
  };

  useEffect(() => {
    getEcole();
    console.table(info);
  }, []);
  return (
    <div className='row'>
      <div className='col-sm-12 col-md-8 offset-md-2 col-lg-8 offset-lg-2'>
        <div className='card mb-3'>
          <div className='card-header'>
            <h2 className='text-center '>Résumé</h2>
            <h3 className='text-center'>
              Inscription en ligne au bacc Permanent
            </h3>
          </div>
          <div className='card-body'>
            <div className='container'>
              {/* <h2>Resumé</h2> */}
              {/* <div className='container'> */}
              <div className='row'>
                <div className='col-12'>
                  <div className='row'>
                    <div className='col-12'>
                      <h5 className='text-center'>
                        MINISTERE DE L'EDUCATION NATIONALE ET DE LA FORMATION
                        PROGESSIONNELLE
                      </h5>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-12'>
                      <h4 className='text-center'>( M E N F P )</h4>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-12'>
                      <h5 className='text-center'>{kk.titre}</h5>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-12'>
                      <h5 className='text-center'>{ss.DENOMSI}</h5>
                    </div>
                  </div>

                  {candidatSelectionne && candidatSelectionne.NOMEL && (
                    <div className='row mx-1 mt-2 d-flex justify-content-center'>
                      <div className='col-12 d-flex border rounded'>
                        {/* <h2 className='text-center'>Candidat Selectionné</h2> */}
                        <div>
                          <div
                            className='mt-2 d-flex flex-direction-center'
                            style={{ width: '100%' }}
                          >
                            {methode_paiement == '0' && (
                              <h4 className='text-center'>
                                Type de Paiement {'  '} BNC{' '}
                                <FaEdit
                                  size={30}
                                  onClick={(e) =>
                                    setCurrentform(currentform - 2)
                                  }
                                />
                              </h4>
                            )}
                            {methode_paiement == '1' && (
                              <h4 className='text-center'>
                                Type de Paiement {'  '} LaJanCach{' '}
                                <FaEdit
                                  size={30}
                                  onClick={(e) =>
                                    setCurrentform(currentform - 2)
                                  }
                                />
                              </h4>
                            )}
                            {methode_paiement == '2' && (
                              <h4 className='text-center'>
                                Type de Paiement {'  '} MonCash{' '}
                                <FaEdit
                                  size={30}
                                  onClick={(e) =>
                                    setCurrentform(currentform - 2)
                                  }
                                />
                              </h4>
                            )}
                          </div>

                          <p>
                            <span className='text-bold ml-1'>
                              Nom et Prenom :
                            </span>
                            {'  '} {candidatSelectionne.NOMEL}{' '}
                            {candidatSelectionne.PRENOMEL}{' '}
                          </p>
                          <p>
                            <span className='text-bold ml-1'>
                              Lieu de Naissance :
                            </span>
                            {'  '}
                            {candidatSelectionne.LOCNAISS}
                          </p>
                          <p>
                            <span className='text-bold ml-1'>
                              Date de Naissance :
                            </span>
                            {format(
                              addDays(
                                new Date(
                                  candidatSelectionne.DNAISS.substr(0, 4)
                                    .concat('-')
                                    .concat(
                                      candidatSelectionne.DNAISS.substr(4, 2)
                                    )
                                    .concat('-')
                                    .concat(
                                      candidatSelectionne.DNAISS.substr(6, 2)
                                    )
                                ),
                                1
                              ),
                              'dd/MM/yyyy'
                            )}
                          </p>
                          <p>
                            <span className='text-bold ml-1'>Niveau :</span>
                            {'Philo :' +
                              candidatSelectionne.IDSECTION.substr(1, 1)}
                          </p>
                          <p>
                            <span className='text-bold ml-1'>Email :</span>
                            {email}
                          </p>
                          <p>
                            <span className='text-bold ml-1'>Telephone :</span>
                            {tel}
                          </p>
                          <p>
                            <span className='text-bold ml-1'>
                              Utilisateur :
                            </span>
                            {info.username ? info.usename : 'sois-meme'}
                          </p>
                        </div>
                      </div>
                      <button
                        className='btn btn-primary my-3'
                        onClick={enregistrer}
                      >
                        {' '}
                        Oui, ces Informations sont Correctes
                      </button>
                    </div>
                  )}
                </div>
              </div>
              {/* </div> */}

              {/* <button
                className='btn btn-small btn-info mt-4'
                onClick={(e) => setCurrentform(currentform - 1)}
              >
                Email&&Tel
              </button> */}
            </div>
          </div>

          <div className='card-footer'>
            {/*            
            <div className='d-flex justify-content-between mt-3'>
              <button
                className='btn btn-small btn-info'
                onClick={(e) => setCurrentform(currentform - 1)}
              >
                Siège
              </button>
              <button
                className='btn btn-small btn-info'
                onClick={(e) => {
                  candidatSelectionne &&
                  candidatSelectionne.NOMEL &&
                  candidatSelectionne.NOMEL.length > 0
                    ? setCurrentform(currentform + 1)
                    : alert(
                        `Il Faut selectionner l'annee academique et le matricule du candidat`
                      );
                }}
              >
                Email
              </button>
            </div>
          */}
          </div>
        </div>
      </div>
    </div>

    /**  $$$$$$$$$$$$$$$$$$$$$$   $$$$$$$$$$$$$$$$$$$$$$$ */
  );
};

export default Resume_perm;
